export const EditIcon = ({fill, ...props}) => {
    return (
        <svg
            width={20}
            height={20}
            fill={fill ? fill : '#7166F6'}
            {...props}
        >
            <path
                d="M16.458 12.5V15c0 2.015-1.11 3.125-3.125 3.125H5c-2.015 0-3.125-1.11-3.125-3.125V6.667c0-2.015 1.11-3.125 3.125-3.125h2.5a.625.625 0 0 1 0 1.25H5c-1.314 0-1.875.56-1.875 1.875V15c0 1.314.56 1.875 1.875 1.875h8.333c1.315 0 1.875-.56 1.875-1.875v-2.5a.625.625 0 0 1 1.25 0Zm1.667-7.453c0 .489-.192.948-.538 1.293l-7.47 7.436a.626.626 0 0 1-.44.182h-3.01a.625.625 0 0 1-.625-.625v-3.009c0-.165.065-.324.182-.44l7.436-7.47a1.815 1.815 0 0 1 1.293-.539h.003c.488 0 .947.19 1.293.536l1.341 1.34c.345.347.536.807.535 1.296Zm-3.444 2.422-2.15-2.15-5.24 5.263v2.127h2.127l5.263-5.24Zm2.194-2.424c0-.155-.06-.3-.17-.41l-1.34-1.34a.575.575 0 0 0-.82 0l-1.132 1.138 2.155 2.154 1.137-1.133a.577.577 0 0 0 .17-.409Z"
            />
        </svg>
    );
}